<template><svg version="1.1" id="Слой_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
     viewBox="0 0 240.77 263.16" style="enable-background:new 0 0 240.77 263.16;" xml:space="preserve">
<g>
	<g>
		<path d="M58.32,101.68c0.9,4.77,11.23,40.65,42.84,40.65s41.94-35.87,42.84-40.65c4.39-0.26,10.58-15.48,10.58-25.42
			s-6.45-8.39-6.45-8.39s3.35-8.65,3.35-18.32c0-18.06-4.1-30.06-15.23-32.19C132.68,10.87,119.48,0,101.16,0
			S72.52,10.48,67.87,14.58c-4.45,3.93-17.03,16.9-17.03,34.97c0,9.68,3.35,18.32,3.35,18.32s-6.45-1.55-6.45,8.39
			S53.93,101.42,58.32,101.68z"/>
        <path d="M196.26,165.86c-5.65-6.99-14.45-8.44-22.87-11.59c-13.93-5.23-22.94-8.98-35.91-17.69l-22.25,68.2l-8.52-23.75
			c0,0,8.18-10.48,8.18-18.95c0-3.97-2.89-9.95-13.73-9.95s-13.73,5.98-13.73,9.95c0,8.47,8.18,18.95,8.18,18.95l-8.51,23.75
			l-22.26-68.2c-12.97,8.71-21.98,12.46-35.91,17.69C14.99,159.49,0,160,0,188.84c0,12.58,2.13,27,2.13,27S39.74,240,101.16,240
			c16.6,0,31.44-1.77,44.28-4.35c-1.31-4.71-2.03-9.66-2.03-14.79C143.41,191.2,166.88,167.02,196.26,165.86z"/>
	</g>
    <path d="M198.55,178.55c-23.37,0-42.3,18.94-42.3,42.3c0,23.37,18.94,42.3,42.3,42.3c23.37,0,42.31-18.94,42.31-42.3
		C240.85,197.49,221.91,178.55,198.55,178.55z M215.98,215.14l-18.95,18.95c-1.04,1.04-2.4,1.56-3.76,1.56s-2.73-0.52-3.76-1.56
		l-8.24-8.24c-2.08-2.08-2.08-5.44,0-7.53c2.08-2.08,5.45-2.08,7.53,0l4.48,4.48l15.19-15.19c2.08-2.08,5.45-2.08,7.53,0
		C218.06,209.69,218.06,213.06,215.98,215.14z"/>
</g>
</svg>
</template>